import { Box } from "@mui/material";
import BreadcrumbNav from "../breadcrumb/breadcrumb.component";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

const TopBar = () => {
  const { id } = useParams();

  const type = useSelector((state) => state?.me?.data?.data?.type);
  const company_name = useSelector(
    (state) => state?.me?.data?.data?.company_name
  );
  const users = useSelector((state) => state.users?.data?.data);
  const fields = useSelector((state) => state.fields?.data);
  const instruments = useSelector((state) => state.instruments?.data?.data);

  const user = Array.isArray(users)
    ? users.find((u) => String(u.id) === String(id))
    : null;
  const field = fields?.data?.find((f) => String(f?.id) === String(id)) || "";
  const instrument = instruments?.find((i) => i?.id === id) || "";
  const isAdmin = type === "Admin";

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "50px",
        position: "static",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <BreadcrumbNav
        type={type}
        company_name={isAdmin ? user?.company_name : company_name}
        fieldName={field?.name}
        instrument={instrument?.nickname}
      />
    </Box>
  );
};

export default TopBar;
